export const balloonActionsModes = {
    grouped: 'grouped',
    inline: 'inline',
};